import { FunctionComponent} from "react";
import ReactMarkdown from "react-markdown";
import { Box } from "@mui/material";

import Modal from "../Modal";

export type Props = {
    open: boolean;
    setOpen: (open: boolean) => void;
    termsMarkdown: string;
};

const OrderTerms: FunctionComponent<Props> = ({ open, setOpen, termsMarkdown }) => {
    return (
        <Modal data-cy="terms-modal" aria-label="Vilkår for verkstedet" openModal={open} toggleModal={() => setOpen(!open)} maxWidth="lg">
            <Box sx={{ padding: { xs: 3, sm: 5 } }}>
                <ReactMarkdown>{termsMarkdown}</ReactMarkdown>
            </Box>
        </Modal>
    );
};

export default OrderTerms;